import { createContext, type PropsWithChildren, type ReactNode, useContext } from 'react';

export const PagePropsContext = createContext<unknown | undefined>(undefined);

export const PagePropsProvider = <T,>({ children, ...pageProps }: PropsWithChildren<T>): ReactNode => {
  return <PagePropsContext.Provider value={pageProps}>{children}</PagePropsContext.Provider>;
};

export const usePageProps = <T,>(): T => {
  const context = useContext(PagePropsContext);
  if (context === undefined) {
    throw new Error('usePageProps must be used within a PagePropsProvider');
  }
  return context as T;
};
